import styled from 'styled-components';
import Nav from '../../components/Nav';
import { Body, PageContainer } from '../../components/Layout';
import { mediaQueries } from '../../constants/breakpoints';
import Header from '../../components/Header';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryFallback, ErrorBoundaryHandler } from '../../components/ErrorBoundary';
import { useParams } from 'react-router-dom';
import ExportChatsContainers from '../../containers/ExportChatsContainers';

const CustomersContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  max-width: 100%;
  overflow-y: auto;
  @media ${mediaQueries.desktop} {
    height: calc(100% - 30px);
    margin: 15px;
  }
`;

const ExportChats = () => {

  const params = useParams();

  return (
    <>
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onError={ErrorBoundaryHandler}
      >
        <Header />
      </ErrorBoundary>
      <PageContainer>
        <ErrorBoundary
          FallbackComponent={ErrorBoundaryFallback}
          onError={ErrorBoundaryHandler}
        >
          <Nav currentStep="stores" />
        </ErrorBoundary>
        <Body>
          <CustomersContainer>
            <ErrorBoundary
              FallbackComponent={ErrorBoundaryFallback}
              onError={ErrorBoundaryHandler}
            >
              <ExportChatsContainers storeId={params.storeId} />
            </ErrorBoundary>
          </CustomersContainer>
        </Body>
      </PageContainer>
    </>
  );
};

export default ExportChats;
